import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { SubCoverageApiResponse } from '../../models/coverages/coverage-api.model'
import { hasActualValue } from '@core/utils/form-utils'

@Injectable({
  providedIn: 'root'
})
export class SubcoverageService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.subcoverageApiUrl

  public getById(uuid: string): Observable<SubCoverageApiResponse> {
    return this.http.get<SubCoverageApiResponse>(`${this.apiUrl}/${uuid}`)
  }

  public create(subcoverage: SubCoverageApiResponse): Observable<SubCoverageApiResponse> {
    return this.http.post<SubCoverageApiResponse>(this.apiUrl, subcoverage)
  }

  public update(subcoverage: SubCoverageApiResponse): Observable<SubCoverageApiResponse> {
    return this.http.put<SubCoverageApiResponse>(this.apiUrl, subcoverage)
  }

  public save(subcoverage: SubCoverageApiResponse): Observable<SubCoverageApiResponse> {
    return hasActualValue(subcoverage.uuid)
      ? this.update(subcoverage)
      : this.create(subcoverage)
  }
}
